import type { LoginInput, RegisterInput } from '@booknest/shared';

import { apiClient } from '@/shared/api/client.js';

export interface AuthResponse {
  user: {
    id: string;
    email: string;
    displayName: string;
    role: 'user' | 'superadmin';
  };
  tokens: { accessToken: string; accessTokenExpiresAt: string };
}

export const authApi = {
  async register(input: RegisterInput): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/register', input);
    return data;
  },

  async login(input: LoginInput): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/login', input);
    return data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },
};
